/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Button, Carousel, Modal, Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import rightArrow from "../../Assets/Icons/rightArrow.png"
import leftArrow from "../../Assets/Icons/leftArrow.png";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { generateInitials, getcombinedClientsAndAgents } from "../../Common/utils/universalFuntions";
import ShareLinkModal from "../../Common/components/ShareLinkModal";
import { Loading } from "../../Common";
import { DocumentSign } from "./DocumentSign";
import { EmailFile } from "./EmailFile";
import { AddEmailModalRtd } from "./AddEmailModalRtd";
import { transactionLaneDataHandle } from "../state/actions";
import { contractDataHandle } from "../../CreateOffer/state/actions";
import { shallowEqual } from "react-redux";

const {TabPane} = Tabs;

const ClientPortaModal = ({
  showmodal,
  setShowModal,
  Role,
  offerid,
  personId,
  propertyId,
  delegate,
  clientNullCheck,
  setIsModalOpen,
  isModalOpen,
  filterSort,
  selectedData,
  userAuthKey,
}) => {
  const [activeTabKey, setActiveTabKey] = useState("1");
  const dispatch = useDispatch();
  const [highlight, setHeighlight] = useState(null);
  const [shareLinkModalOpen, setShareLinkModalOpen] = useState(false);
  const [callPropertyDocsApi, setCallPropertyDocsApi] = useState(false);
  let { propertyDocsWithoutSection, generateDashboardLinkLoading, dashboarUrl, propertDocsWithoutSectionLoading, propertDocsLoading} = useSelector((state) => state.rtdTransactionLane);
  let { propertyDocs, contactDocs, propertDocsError, personDocs, personDocsLoading, personDocsError } = useSelector((state) => state.createOffer, shallowEqual);
  const { getIndividualTransactionData } = useSelector((state) => state.rtdTransactionLane);
  const isMobile = useMediaQuery({maxWidth: 545});
  const isTab = useMediaQuery({minWidth: 546 ,maxWidth: 760});
  const isLarge = useMediaQuery({minWidth: 761 ,maxWidth: 990});

  const spot1 = useMediaQuery({minWidth: 420, maxWidth: 540});
  const spot2 = useMediaQuery({minWidth: 615, maxWidth: 759});
  const spot3 = useMediaQuery({minWidth: 870, maxWidth: 990});



  const buildQuery = (highlight) => {
    return  {
      ...(offerid ? { offerId: offerid } : {}),
      ...(propertyId ? { propertyId: propertyId } : {}),
      ...(Role ? { role: Role } : {}),
      ...(highlight?.key ? { key: highlight?.key } : { key: highlight?._id }),
      ...(highlight?._id ? { _id: highlight?._id } : {}),
    };
  }

  let unmounted = {
    value: false
  };
  let source = axios.CancelToken.source();

  useEffect(() => {
    let type="SendEmail"
    let params = {
      ...(offerid ? { offerId: offerid } : {}),
      ...(propertyId ? { propertyId: propertyId } : {}),
      openFor:(Role ==="SELLER")? "SELLER_AGENT" : "BUYER_AGENT",
      personId:personId,
      ...(delegate ? ((Role ==="SELLER")) ? { delegateSide: "SELLER" } : { delegateSide: "BUYER" } : {}),
    };
  dispatch(contractDataHandle.getPropertyDocsFun({ params, unmounted, source,type, contractAuthKey: userAuthKey }));
  return () => {
    unmounted.value = true;
    source.cancel("Cancelling in cleanup");
  }
}, [callPropertyDocsApi]);

const combinedClientsData = useMemo(() => {
  const data = getcombinedClientsAndAgents({
    allContractDocuments: propertyDocsWithoutSection || [],
    propertySellerIds: Role === "SELLER" ? getIndividualTransactionData?.sellerIds : [],
  });
  return {
    combinedSellerIds: data.combinedSellerIds,
  };
}, [propertyDocsWithoutSection, getIndividualTransactionData]);


function firstSeller(){
  if(combinedClientsData?.combinedSellerIds?.length > 0){
  const firstSeller = (combinedClientsData?.combinedSellerIds)?.[0];
 if(firstSeller?.isCorp){
    return {
      idx: "00",
      key: firstSeller?.key,
      ...(firstSeller?.signers?.[0]?.personId || {})
    }
  }
  else{
    return {
      idx: "0",
      ...(firstSeller?.personId || {})
    }
  }
}
}

useEffect(()=>{
  let nullFound=false;
  if(combinedClientsData?.combinedSellerIds?.length > 0){
    nullFound = clientNullCheck({clientIds: combinedClientsData?.combinedSellerIds})
if (nullFound) {
  setIsModalOpen({...isModalOpen,isAllEmailsModalOpen:true,isEmailModalVisible:false})
  }else{
  setIsModalOpen({...isModalOpen,isAllEmailsModalOpen:false})
  setHeighlight(firstSeller())
  }

}
},[propertyDocsWithoutSection])

useEffect(() => {
if((combinedClientsData?.combinedSellerIds.length > 0) && propertyDocsWithoutSection?.length > 0){
  setActiveTabKey("1");
    const query = buildQuery(highlight, offerid, propertyId, Role);
    dispatch(transactionLaneDataHandle.ClientPortalData({query, userAuthKey}));
  }}, [highlight]);


  const handleTabChange = (ele) => {
    setActiveTabKey(ele);
    if(ele === "1"){
      let query = buildQuery(highlight);
      dispatch(transactionLaneDataHandle.ClientPortalData({query,userAuthKey}));
    }
    else {
      let query = {
        ...(offerid ? { offerId: offerid } : {}),
        ...(propertyId ? { propertyId: propertyId } : {}),
        ...(Role ? { role: Role } : {}),
        ...(highlight?._id ? { _id: highlight?._id } : {}),
      };
      const params = {
        ...(offerid ? { offerId: offerid } : {}),
        ...(propertyId ? { propertyId: propertyId } : {}),
        openFor: Role,
        ...(highlight?._id ? { personId: highlight?._id } : {}),
      };
      dispatch(transactionLaneDataHandle.getPropertyDocsFunUpload({ params, source, userAuthKey }));
      dispatch(transactionLaneDataHandle.EmailFileData(query,userAuthKey));
    }
  }
  const handleDashboardButtonClick = () => {
    const payload = {
      ...(offerid ? { offerId: offerid } : {}),
      ...(propertyId ? { propertyId: propertyId } : {}),
      ...(Role ? { openFor: Role } : {}),
      ...(highlight?.key ? { key: highlight?.key } : { key: highlight?._id }),
      ...(highlight?._id ? { personId: highlight?._id } : {}),
    };
    dispatch(transactionLaneDataHandle.generateDashboardLinkFun(payload, userAuthKey));
    setShareLinkModalOpen(true);
}
  const shareLinkModalCanel = () => {
    setShareLinkModalOpen(false);
  }
  
  let clientCount = isMobile ? 1 : isTab ? 2 : isLarge ? 3 : 4;
  let multipleFour = 0;
  const settings = {
    nextArrow: <img src={rightArrow} alt=""/>,
    prevArrow: <img src={leftArrow} alt=""/>
  };

  let arrayTemp = [];

  return (
    <>
      {shareLinkModalOpen && <ShareLinkModal title={"Share Dashboard Link"} shareLinkModalLoading={generateDashboardLinkLoading} shareLinkModalOpen={shareLinkModalOpen} shareLinkModalCancel={shareLinkModalCanel} shareableUrl={dashboarUrl} source="CLIENT_PORTAL" selectedClient={highlight} />}
  {!isModalOpen.isAllEmailsModalOpen ?
  <Modal
      visible={showmodal}
      onOk={() => {}}
      footer={false}
      width={"960px"}
      style={{ marginTop: "-75px" }}
      onCancel={() => {
        setShowModal(false)
   }}
    >
      <div
        style={{
          textAlign: "center",
          color: "#888888",
          overFlow: "auto",
          height: `calc(100vh - 6.2rem)`,
          fontSize: "18px",
          padding: "5px",
          // boxShadow:
          //   "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          borderBottomRightRadius: "5px",
          borderBottomLeftRadius: "5px",
        }}
      >
        <div style={{ fontWeight: "bold" }}>Client Portal</div>
        <div
          style={{
            padding: "0px 30px"
          }}
        >
      {propertDocsLoading  ? (
        <div>
          <Loading />
        </div> ):   
        <Carousel dots={false} arrows {...settings}>
            {/* made rendering corp specific with added logic */}
            {
              (combinedClientsData?.combinedSellerIds)?.map((seller, index) => {
                let endOfSeller = (index === (combinedClientsData?.combinedSellerIds?.length - 1))
                if(seller?.isCorp){
                  return seller?.signers?.map((signer, idx)=> {
                    let endOfSigner = (idx === (seller?.signers?.length - 1))
                    arrayTemp[multipleFour%clientCount] =  profileView({profile: signer, corpName: seller?.fullName, idx: (index + "" + idx), key: seller?.key, highlight, setHeighlight,isMobile,spot1,spot2,spot3})
                    ++multipleFour;
                    if((multipleFour%clientCount == 0) || (endOfSeller && endOfSigner && ((multipleFour%clientCount)>0))){
                      let renderArray = [...arrayTemp];
                      arrayTemp = [];
                      return <div><div style={{display: "flex", flexDirection: "row"}}>{renderArray.map((ele)=>ele)}</div></div>
                    }
                  })
                }
                else{
                  arrayTemp[multipleFour%clientCount] = profileView({profile: seller, idx: (index + ""), highlight, setHeighlight,isMobile,spot1,spot2,spot3});
                  ++multipleFour;
                  if((multipleFour%clientCount == 0) || (endOfSeller && ((multipleFour%clientCount)>0))){
                    let renderArray = [...arrayTemp];
                    arrayTemp = [];
                    return <div><div style={{display: "flex", flexDirection: "row"}}>{renderArray.map((ele)=>ele)}</div></div>
                  }
                }
              })
            }
          </Carousel>
}
          
        </div>
        <div style={{ width: "100%" }}>
        {propertDocsLoading ? (
        <div>
          <Loading />
        </div> ): <div style={{ display: "flex", width: "100%", fontSize: "15px" }}>
            <Tabs
              activeKey={activeTabKey}
              onChange={handleTabChange}
              defaultActiveKey="1"
              style={{ width: "100%", height: "calc(100vh - 8.4rem)" }}
              className="centered-tabs"
                    tabBarGutter={10}
                    tabBarExtraContent={{
                      right: (
                        <Button type="primary" onClick={() => handleDashboardButtonClick()}>Dashboard Link</Button>
                      ),
                    }}
            >
              <TabPane
                tab="Document Signing"
                key="1"
                style={{ width: "100%", height: "100%", paddingTop: "15px" }}
              >
                <DocumentSign
                  id={combinedClientsData?.combinedSellerIds?.[0]?.personId?._id}
                  offerIds={offerid}
                  role={Role}
                />
              </TabPane>
              <TabPane
                tab="Email & Files"
                key="2"
                style={{ width: "100%", height: "100%", fontSize: "18px" }}
              >
                <EmailFile
                  id={combinedClientsData?.combinedSellerIds?.[0]?.personId?._id}
                  offerIds={offerid}
                  role={Role}
                />
                    </TabPane>
                   
                  </Tabs>
                 
          </div>}
        </div>
      </div>
    </Modal>:
    <AddEmailModalRtd modalVisible={isModalOpen} setModalVisible={setIsModalOpen} selectedData={selectedData} combinedClients={combinedClientsData?.combinedSellerIds} seller={"SELLER"} filterSort={filterSort} delegateSide={delegate && ("SELLER")} offerId={offerid} propertyId={ propertyId} setShowModal={ setShowModal} userAuthKey={userAuthKey} callPropertyDocsApi={callPropertyDocsApi} setCallPropertyDocsApi={setCallPropertyDocsApi} source={"CLIENT_PORTAL"} />
   } </>
  );
};

const profileView = ({ profile, corpName, idx, key, highlight, setHeighlight, isMobile, spot1, spot2, spot3 }) => {
  // console.log("Profile", profile);
  const initials = generateInitials(profile?.personId?.fullName || profile?.fullName);
  const handleclientPortal = () => {
    setHeighlight({
      idx,
      ...(profile?.personId || {}),
      ...(key ? {key} : {})
    })
  };

  return <div key={idx}>
    <div
      style={{
        width: spot3 ? "250px" : spot2 ? "250px" : spot1 ? "300px" : isMobile ? "230px" : "206px", // Adjust the width as needed
        height: "70px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        cursor: "pointer",
        padding: "8px", // Adjust the padding as needed
        margin: "2px", // Adjust the margin as needed
        display: "flex",
        alignItems: "center",
        backgroundColor: (highlight?.idx === idx) ? "#96c8f6" : "white"
      }}
      onClick={() => handleclientPortal()}
    >
      {profile?.personId?.profileImg?.original &&
      profile?.personId?.profileImg?.original !==''?
      <Avatar
        src={profile?.personId?.profileImg?.original}
        style={{
          backgroundColor: "#0078d4",
          borderRadius: "50%",
          objectFit:"cover"
        }}
        size={40}
      /> :
      <Avatar
        src={null}
        style={{
            backgroundColor: "#0078d4",
            borderRadius: "50%",
        }}
        size={40}
      >
        {initials}
      </Avatar>
      }
      <div style={{ flex: 1 }}>
        <div
          style={{
            overflow: "hidden",
            textAlign: "left",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "140px",
            fontWeight: "500",
            color: "#333",
            fontSize: "16px",
            marginLeft: "10px",
          }}
        >
          {profile?.fullName}
        </div>
        {
          corpName ?
          <div
            style={{
              overflow: "hidden",
              textAlign: "left",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "120px",
              fontSize: "16px",
              color: "#555",
              marginLeft: "10px",
            }}
         >
           {corpName}
         </div> : ""
        }
      </div>
    </div>
    
  </div>
}

export { ClientPortaModal };
